<template>
  <div>
    <b-modal
      hide-footer
      size="xl"
      title="Add Event Pricekinetic"
      centered
      id="event-pricekinetic"
      @hide="handleClose"
    >
      <div style="min-height: 300px" class="text-black">
        <div class="d-flex align-items-center justify-content-end mb-1">
          <b-button variant="secondary" class="mr-1" @click="handleClose">
            <feather-icon icon="SaveIcon" />
            Cancel
          </b-button>
          <b-button
            :disabled="loadingSaveList || !listSelectedEvent.length"
            variant="primary"
            @click="handleSaveListEvent"
            style="width: 220px"
          >
            <feather-icon icon="SaveIcon" style="margin-right: 5px" />
            <Spinner v-if="loadingSaveList" />
            <template v-else>Save Selected Events </template>
          </b-button>
        </div>
        <b-row>
          <b-col cols="12" lg="4">
            <div style="border: 1px solid #0000001a; height: 100%">
              <div class="p-1 d-flex justify-content-between">
                <h5 class="text-body mb-0">Sports ({{ totalSports }})</h5>
                <!-- <div class="d-flex align-items-center">
                <span class="" style="margin-right: 8px"></span>
                <b-form-checkbox v-model="checkActiveSport" switch />
                <span>Active Only</span>
              </div> -->
                <b-button
                  variant="success"
                  @click="$bvModal.show('sport-pricekinetic')"
                >
                  <feather-icon icon="PlusIcon" />
                  Add Sport
                </b-button>

                <AddSportPricekinetic @refresh="handleReloadListSport" />
              </div>
              <div class="bg-white">
                <!-- LIST SPORTS SECTION -->
                <draggable
                  :list="sports"
                  :group="{ name: 'sports' }"
                  :sort="true"
                  class="d-flex flex-column"
                >
                  <div
                    v-for="(sport, index) in sports"
                    :key="sport.id"
                    class="d-flex align-items-center p-1"
                    :class="{
                      'border-bottom': index !== sports.length - 1,
                      'bg-blue-50': selectedSport.id === sport.id,
                    }"
                    @click="selectSport(sport)"
                    style="cursor: pointer; gap: 16px"
                  >
                    <feather-icon icon="AlignCenterIcon" class="text-muted" />
                    <div class="flex-1 w-100">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <b-badge :variant="formatColor(sport.name)" pill>{{
                            sport.name
                          }}</b-badge>
                        </div>

                        <div class="d-flex align-items-center" style="gap: 8px">
                          <b-badge
                            :variant="
                              sport.status !== 'active'
                                ? 'secondary'
                                : 'light-success'
                            "
                            pill
                            >{{ sport.status }}</b-badge
                          >
                        </div>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <p class="small text-muted mb-0">
                          {{ sport.leagueCount }} Leagues
                        </p>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
              <!-- <p
              v-if="totalSports > sports.length"
              class="cursor-pointer mt-1 ml-1 show-more"
              @click="currentPageSports = currentPageSports + 1"
            >
              Show more
            </p> -->
            </div>
          </b-col>

          <b-col cols="12" lg="8">
            <div v-if="selectedSport" style="border: 1px solid #0000001a">
              <div
                class="d-flex justify-content-between align-items-center p-1 border-bottom"
              >
                <div class="d-flex align-items-center">
                  <b-button
                    v-if="selectedLeague"
                    variant="outline"
                    size="sm"
                    style="cursor: pointer"
                    @click="handleBack"
                  >
                    <feather-icon icon="ChevronLeftIcon" class="text-muted" />
                  </b-button>
                  <h5 class="text-body mb-0">
                    {{
                      !selectedLeague
                        ? `${selectedSport.name} Leagues (${totalLeagues})`
                        : ` ${selectedLeague.name}`
                    }}
                  </h5>
                </div>
             

                <b-button v-if="!selectedLeague"
                  variant="success"
                  @click="$bvModal.show('league-pricekinetic')"
                >
                  <feather-icon icon="PlusIcon" />
                  Add League
                </b-button>

                <AddLeaguePricekinetic
                  @refresh="handleReloadListLeague"
                  v-if="selectedSport"
                  :selectedSport="selectedSport"
                />
              </div>

              <div class="bg-white">
                <!-- LEAGUES SECTION -->
                <template v-if="!selectedLeague">
                  <div
                    v-for="(league, index) in leagues"
                    :key="league.name"
                    class="d-flex align-items-center p-1"
                    :class="{
                      'border-bottom': index !== leagues.length - 1,
                    }"
                    style="gap: 16px; cursor: pointer"
                    @click="selectLeague(league)"
                  >
                    <feather-icon icon="AlignCenterIcon" class="text-muted" />
                    <div class="flex-1 w-100">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center" style="gap: 8px">
                          <b-badge
                            :variant="
                              league.status === 'active'
                                ? 'success'
                                : 'secondary'
                            "
                            pill
                            style="max-width: 300px; white-space: normal"
                          >
                            🏆 {{ league.name }}
                          </b-badge>
                          <b-badge
                            :variant="
                              league.status === 'active'
                                ? 'light-success'
                                : 'secondary'
                            "
                            class="text-capitalize"
                            pill
                            style="height: 21px"
                            >{{ league.status }}</b-badge
                          >
                        </div>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center mt-1"
                      >
                        <div class="d-flex flex-column">
                          <span class="font-weight-bold"> Australia </span>
                          <span class="text-muted">{{
                            formatTime(league.createdTime, "yyyy")
                          }}</span>
                        </div>
                      
                      </div>
                    </div>
                  </div>

                  <!-- <p
                  v-if="totalLeagues > leagues.length"
                  class="cursor-pointer mt-1 ml-1 show-more"
                  @click="currentPageLeagues = currentPageLeagues + 1"
                >
                  Show more
                </p> -->
                </template>

                <!-- LIST EVENT SECTION -->
                <template v-if="selectedLeague">
                  <div
                    v-for="(event, index) in events"
                    :key="event.eventId"
                    class="d-flex align-items-center p-1 text-black"
                    :class="{
                      'border-bottom': index !== totalEvents - 1,
                      'bg-blue-100': listSelectedEvent.some(
                        (i) => i.eventID === event.eventID
                      ),
                    }"
                    style="gap: 16px; cursor: pointer"
                    @click="selectEvent(event)"
                  >
                    <feather-icon icon="AlignCenterIcon" class="text-muted" />
                    <div class="flex-1 w-100">
                      <div
                        class="d-flex align-items-center justify-content-between"
                        style="gap: 16px"
                      >
                        <div
                          class="d-flex align-center justify-content-between flex-1"
                          style="gap: 8px"
                        >
                          <p
                            style="line-height: 15px"
                            class="font-weight-bold mb-0 d-flex flex-column"
                          >
                            {{ event.eventTitle }}
                          
                          </p>
                        </div>

                        <div class="d-flex flex-column">
                          <span>Event ID: {{ event.eventID }}</span>
                          <span>EventType: {{ event.eventType }} </span>
                        </div>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <span class="text-muted">
                            <feather-icon icon="ClockIcon" class="text-muted" />
                            {{
                              formatTime(event.startTime, "dd MMM hh:mm aa")
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <p
                  v-if="totalEvents > events.length"
                  class="cursor-pointer mt-1 ml-1 show-more"
                  @click="currentPageEvents = currentPageEvents + 1"
                >
                  Show more
                </p> -->
                </template>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BInputGroupPrepend,
  BBadge,
  BFormCheckbox,
  BModal,
  BFormTextarea,
  BFormRadio,
  BFormGroup,
  BFormRadioGroup,
  BInputGroupAppend,
  BFormFile,
} from "bootstrap-vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import FeatureIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { formatTime, formatDateSend } from "@/helpers/utils";
import Spinner from "@/@core/components/Spinner.vue";
import AddSportPricekinetic from "./AddSportPricekinetic.vue";
import AddLeaguePricekinetic from "./AddLeaguePricekinetic.vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BInputGroupPrepend,
    BBadge,
    draggable,
    BFormCheckbox,
    BModal,
    BFormTextarea,
    vSelect,
    flatPickr,
    BFormRadio,
    BFormGroup,
    FeatureIcon,
    BFormRadioGroup,
    Spinner,
    BInputGroup,
    BInputGroupAppend,
    BFormFile,
    AddSportPricekinetic,
    AddLeaguePricekinetic,
  },
  data() {
    return {
      selectedSport: null,
      sports: [],
      perPageSports: 100,
      currentPageSports: 1,
      totalSports: 0,
      leagues: [],
      perPageLeagues: 100,
      currentPageLeagues: 1,
      totalLeagues: 0,
      selectedLeague: null,
      selectedEvent: null,
      isEditEvent: false,
      events: [],
      perPageEvents: 100,
      currentPageEvents: 1,
      totalEvents: 0,

      checkActiveSport: true,
      checkActiveLeague: true,
      checkUpcomingEvent: true,

      listSelectedEvent: [],
      loadingSaveList: false,
    };
  },
  watch: {
    currentPageSports(newPage) {
      if (newPage > 1) this.fetchSports();
    },
    currentPageLeagues(newPage) {
      if (newPage > 1) this.fetchLeagues();
    },
    currentPageEvents(newPage) {
      if (newPage > 1) this.fetchtEvent();
    },
    currentPageMarkets(newPage) {
      if (newPage > 1) this.fetchtMarkets();
    },
    checkActiveSport() {
      this.fetchSports();
    },
    checkActiveLeague() {
      this.fetchLeagues();
    },
    checkUpcomingEvent() {
      this.fetchtEvent();
    },
  },
  async mounted() {
    await this.handleReloadListSport();
  },
  computed: {
    ...mapState("sport/create", ["loadingCreateMarket", "loadingCreateEvent"]),
  },
  methods: {
    ...mapActions({
      getListSport: "sport/list/getListSport",
      getListLeagueOfSport: "sport/list/getListLeagueOfSport",
      getListEventOfLeague: "sport/list/getListEventOfLeague",
      getListEventPricekinetic: "sport/list/getListEventPricekinetic",
      createEvent: "sport/create/createEvent",
    }),
    async fetchSports() {
      const data = await this.getListSport({
        limit: this.perPageSports,
        page: this.currentPageSports,
        ...(this.checkActiveSport && { status: "active" }),
        source: "pricekinetic",
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      if (this.currentPageSports === 1) {
        this.sports = data.data;
      } else {
        this.sports = [...this.sports, ...data.data];
      }
      this.totalSports = data.pagination.total;
    },
    async fetchLeagues() {
      const data = await this.getListLeagueOfSport({
        limit: this.perPageLeagues,
        page: this.currentPageLeagues,
        sportId: this.selectedSport.id,
        // ...(this.checkActiveLeague && { onlyUpcoming: true }),
        source: "pricekinetic",
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      if (this.currentPageLeagues === 1) {
        this.leagues = data.data;
      } else {
        this.leagues = [...this.leagues, ...data.data];
      }
      this.totalLeagues = data.pagination.total;
    },
    async fetchtEvent() {
      const res = await this.getListEventPricekinetic({
        limit: this.perPageEvents,
        page: this.currentPageEvents,
        sportCode: this.selectedSport.code,
        league: this.selectedLeague.name,
      });
      const data = res.data.events;

      if (Array.isArray(data)) {
        this.events = data;
        this.totalEvents = data.length;
      }
    },
    async fetchtMarkets() {
      const data = await this.getListMarketOfEvent({
        limit: this.perPageMarkets,
        page: this.currentPageMarkets,
        eventId: this.selectedEvent.eventId,
      });
      const list = data.data.map((market) => ({
        ...market,
        isActive: true,
        selections: market.selections.map((selection) => ({
          ...selection,
          isActive: true,
        })),
      }));
      if (!data && list.length <= 0)
        return this.showToastError(false, "Error fetching markets list");
      if (this.currentPageMarkets === 1) {
        this.markets = list;
      } else {
        this.markets = [...this.markets, ...list];
      }
      this.totalMarkets = data.pagination.total;
    },
    formatColor(name) {
      const colors = [
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "dark",
      ];

      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const index = Math.abs(hash) % colors.length;

      return colors[index];
    },
    async selectSport(sport) {
      this.selectedLeague = null;
      this.selectedEvent = null;
      this.leagues = [];
      this.events = [];
      this.selectedSport = sport;
      this.scrollToTop();
      if (this.currentPageLeagues !== 1) this.currentPageLeagues = 1;
      await this.fetchLeagues();
      this.selectedLeague = null;
      this.selectedEvent = null;
    },
    async selectLeague(league) {
      this.selectedLeague = league;
      await this.fetchtEvent();
      this.scrollToTop();
    },
    async selectEvent(ev) {
      if (this.listSelectedEvent.some((i) => i.eventID === ev.eventID))
        return (this.listSelectedEvent = this.listSelectedEvent.filter(
          (i) => i.eventID !== ev.eventID
        ));
      this.listSelectedEvent = [...this.listSelectedEvent, ev];
    },
    closeModal() {
      this.$refs.marketRef.hide();
    },
    handleBack() {
      if (this.selectedEvent) {
        this.selectedEvent = null;
      } else if (this.selectedLeague) {
        this.selectedLeague = null;
        this.events = []
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleClose() {
      this.listSelectedEvent = [];
      this.$bvModal.hide("event-pricekinetic");
    },
    async handleSaveListEvent() {
      this.loadingSaveList = true;
      await this.saveList();
      this.loadingSaveList = false;
      this.handleClose();
    },
    async saveList() {
      const formatList = this.listSelectedEvent.map((ev) => {
        return this.createEvent({
          eventId: ev.eventID,
          source: "pricekinetic",
          eventTitle: ev.eventTitle,
          startTime: ev.startTime,
          league: ev.league,
          sport: ev.sport,
          country: ev.country,
          primaryMarketName: ev.primaryMarketName,
          displayStatus: ev.displayStatus,
          bettingStatus: ev.bettingStatus,
          detailLink: ev.detailLink,
          brandLinksLadbrokes: ev.brandLinks.ladbrokes,
          brandLinksNeds: ev.brandLinks.neds,
          eventType: ev.eventType,
          entryType: 0,
          stadium: "",
          sportCode: this.selectedSport.code,
          isAllowedPlaceBetting: true,
          isDisableSyncSport: false,
          status: "Scheduled",
          description: "",
          round: "",
        });
      });
      await Promise.all(formatList);
    },
    async handleReloadListSport() {
      await this.fetchSports();
      this.selectedSport = this.sports[0];
      if (this.selectedSport) {
        await this.fetchLeagues();
      }
    },
    async handleReloadListLeague() {
      await this.fetchLeagues();
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
      formatTime,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.show-more {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  color: blue;
}

.selection-market {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.bg-blue-50 {
  background-color: #eff6ff !important;
}
.bg-blue-100 {
  background-color: #d8e6f8 !important;
}
</style>
